function waitForImage(image: HTMLImageElement) {
  if (image.complete) {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    image.addEventListener('load', () => resolve(), { once: true });
    image.addEventListener('error', () => resolve(), { once: true });
  });
}

function waitForFrame() {
  return new Promise<void>((resolve) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => resolve());
    });
  });
}

export async function waitForPrintReadiness(root: HTMLElement) {
  const fontSet = 'fonts' in document ? document.fonts : null;

  await Promise.all([
    fontSet ? fontSet.ready.catch(() => undefined) : Promise.resolve(),
    ...Array.from(root.querySelectorAll('img')).map(waitForImage),
  ]);

  await waitForFrame();
}
